module.exports = __webpack_public_path__ + "static/media/pic2.63f56491.png";